"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ScrollView_1 = require("./ScrollView");
var AutocompleteList = function (props) {
    var children = props.children, contentHeight = props.contentHeight, viewHeight = props.viewHeight, width = props.width, maxVisibleItems = props.maxVisibleItems, hasResults = props.hasResults, theme = props.theme;
    var scrollProps = {
        height: hasResults ? viewHeight : 0,
        width: width,
        top: theme.spacing.base * 5 - 2,
        overflow: maxVisibleItems ? "auto" : "hidden",
        background: theme.colors.textOnDark,
        border: hasResults ? "solid 1px ".concat(theme.colors.baseContrast060) : "none",
        padding: "".concat(hasResults ? theme.spacing.base / 2 : 0, "px 0px"),
    };
    return ((0, jsx_runtime_1.jsx)(ScrollView_1.ScrollView, __assign({}, scrollProps, { children: (0, jsx_runtime_1.jsx)("div", { style: { height: "".concat(contentHeight, "px") }, children: children }) })));
};
exports.AutocompleteList = AutocompleteList;
exports.AutocompleteList.displayName = "AutocompleteList";
//# sourceMappingURL=AutocompleteList.js.map